module.exports = __webpack_public_path__ + "assets/img/label-classify-3.e0f5bbaa.png";